import apiSlice from "./ApiSlice";

const SyllabusApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllSyllabusData: builder.query({
      providesTags: ["syllabus"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/syllabus",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteSyllabusById: builder.mutation({
      invalidatesTags: ["syllabus"],
      query: (id: any) => ({
        url: `/syllabus/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addSyllabus: builder.mutation({
      invalidatesTags: ["syllabus"],
      query: (body) => ({
        url: `/syllabus/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getSyllabusById: builder.query({
      providesTags: ["syllabus"],
      query: (id: string) => {
        return {
          url: `/syllabus/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllSyllabus: builder.query({
      providesTags: ["syllabus"],
      query: () => {
        return {
          url: `/syllabus`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateSyllabusById: builder.mutation({
      invalidatesTags: ["syllabus"],
      query: ({ body, id }) => ({
        url: `/syllabus/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusSyllabusById: builder.mutation({
      invalidatesTags: ["syllabus"],
      query: ({ body, id }) => ({
        url: `/syllabus/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllSyllabusDataQuery,
  useDeleteSyllabusByIdMutation,
  useAddSyllabusMutation,
  useGetSyllabusByIdQuery,
  useUpdateSyllabusByIdMutation,
  useGetAllSyllabusQuery,
  useChangeStatusSyllabusByIdMutation,
} = SyllabusApi;
